import React from "react";
import MenuItemsDynamic from "./MenuItemsDynamic";

const DropdownItemsDynamic = ({ submenus, dropdown, depthLevel, closeMobileMenu }) => {

  depthLevel = depthLevel + 1;
  const dropdownClass = depthLevel > 1 ? "dropdown-submenu-multi" : "";
  return (
    <ul className={`dropdown-multi ${dropdownClass} ${dropdown ? "show-multi" : ""}`}>
      {submenus.map((submenu, index) => (
        <MenuItemsDynamic item={submenu} key={index} depthLevel={depthLevel} closeMobileMenu={closeMobileMenu} />
      ))}
    </ul>
  );
};
export default DropdownItemsDynamic;